module.exports = __webpack_public_path__ + "static/media/main3.bb50c83d.jpg";